/**
 * StaminaComponent - Manages entity stamina for actions
 */

import { Component } from '../Component';
import { ComponentType } from '../../types/enums';

export class StaminaComponent extends Component {
  readonly type = ComponentType.Stamina;

  private currentStamina: number;
  private maxStamina: number;
  private regenRate: number;
  private regenDelay: number;
  private timeSinceUse: number = 0;

  constructor(maxStamina: number = 100, regenRate: number = 20, regenDelay: number = 1) {
    super();
    this.maxStamina = maxStamina;
    this.currentStamina = maxStamina;
    this.regenRate = regenRate;
    this.regenDelay = regenDelay;
  }

  update(deltaTime: number): void {
    this.timeSinceUse += deltaTime;

    // Regenerate stamina after delay
    if (this.timeSinceUse >= this.regenDelay && this.currentStamina < this.maxStamina) {
      this.currentStamina = Math.min(
        this.maxStamina,
        this.currentStamina + this.regenRate * deltaTime
      );
    }
  }

  /** Use stamina, returns true if successful */
  use(amount: number): boolean {
    if (this.currentStamina >= amount) {
      this.currentStamina -= amount;
      this.timeSinceUse = 0;
      return true;
    }
    return false;
  }

  /** Check if has enough stamina */
  hasStamina(amount: number): boolean {
    return this.currentStamina >= amount;
  }

  /** Restore stamina */
  restore(amount: number): void {
    this.currentStamina = Math.min(this.maxStamina, this.currentStamina + amount);
  }

  getCurrentStamina(): number {
    return this.currentStamina;
  }

  getMaxStamina(): number {
    return this.maxStamina;
  }

  getStaminaPercent(): number {
    return this.currentStamina / this.maxStamina;
  }

  setMaxStamina(value: number): void {
    this.maxStamina = value;
    this.currentStamina = Math.min(this.currentStamina, this.maxStamina);
  }
}
